export const PermissionEnum = {
    SOS_VIEW: "sentry.sos.view",
    SOS_MANAGE_CITIZEN: "sentry.sos.manage.citizen",
    SOS_CITIZEN_SCHEDULED_VISIT_MANAGE: "sentry.sos.citizen.scheduled.visit.manage",
    SOS_MANAGE_EVENTS: "sentry.sos.manage.events",
    SOS_MANAGE_PROGRAM: "sentry.sos.manage.program",
    SOS_MANAGE_ALL_PROGRAM: "sentry.sos.manage.all.program",
    SOS_PROTECTION_PROGRAM: "sentry.sos.protection.program",
    SOS_CITIZEN_HISTORY_EDIT: "sentry.sos.citizen.history.edit",
    SOS_ATTACHS_SHOW: "sentry.sos.attachs.show",
    SOS_DASHBOARD: "sentry.sos.dashboard",
    ERP_FLEET: "sentry.erp.fleet",
    ERP_ASSET: "sentry.erp.asset",
    ERP_PERSONAL: "sentry.erp.personal",
    ERP_JANITORIAL: "sentry.erp.janitorial",
    ERP_MATERIALS_RESPONSIBLE: "sentry.erp.materials.responsible",
    ERP_MATERIALS_MANAGE2: "sentry.erp.materials.manage2",
    ERP_MATERIALS_MANAGE: "sentry.erp.materials.manage",
    ERP_MATERIALS_ADJUSTMENT: "sentry.erp.materials.adjustment",
    ERP_FLEET_SUPPLY_EDIT: "sentry.erp.fleet.supply.edit",
    MOBILE_ALARM_RULES_ADMIN: "sentry.mobile.admin",
    ADDRESSES_ADMIN: "sentry.addresses.admin",
    REFERENCE_VEHICLE: "sentry.reference.vehicle",
    REFERENCE_VEHICLES_NOTES: "sentry.reference.vehicles_notes",
    ENCOUNTER: "sentry.encounter",
    ENCOUNTER_EDIT: "sentry.encounter.edit",
    ENCOUNTER_APP: "sentry.encounter.app",
    ENCOUNTER_APP_DISPATCH: "sentry.encounter.app.dispatch",
    BOGCM_APP: "sentry.bogcm.app",
    BOGCM_WEB: "sentry.bogcm.web",
    BOGCM_VIEW_ALL: "sentry.bogcm.view.all",
    BOGCM_VIEW_SUBORDINATES: "sentry.bogcm.view.subordinates",
    BOGCM_VIEW_MY: "sentry.bogcm.view.my",
    BOGCM_EDIT_ALL: "sentry.bogcm.edit.all",
    BOGCM_EDIT_SUBORDINATES: "sentry.bogcm.edit.subordinates",
    BOGCM_EDIT_MY: "sentry.bogcm.edit.my",
    BOGCM_REVIEW_ALL: "sentry.bogcm.review.all",
    BOGCM_REVIEW_SUBORDINATES: "sentry.bogcm.review.subordinates",
    BOGCM_EVALUATION_ALL: "sentry.bogcm.evaluation.all",
    BOGCM_EVALUATION_SUBORDINATES: "sentry.bogcm.evaluation.subordinates",
    BOGCM_REJECT: "sentry.bogcm.reject",
    BOGCM_RECTIFY: "sentry.bogcm.rectify",
    BOGCM_ADD_OTHER_DOCUMENTS: "sentry.bogcm.add_other_documents",
    BOGCM_INVALIDATE: "sentry.bogcm.invalidate",
    BOGCM_TAGS: "sentry.reference.tags.bogcm",
    REFERENCE_INDIVIDUAL: "sentry.reference.individual",
    INDIVIDUAL_ALARM: "sentry.individual.alarm",
    INDIVIDUAL_MONITORING: "sentry.individual.monitoring",
    INDIVIDUAL_PASSAGE_SEARCH: "sentry.individual.passage.search",
    CONTACTID: "sentry.contactid",
    CONTACTID_ADMIN: "sentry.contactid.admin",
    ANALYSIS_NETWORK: "sentry.analysis.network",
    REPORT_OCCURRENCE_MONITORING: "sentry.report.occurrence.monitoring",
    REPORT_AUDIT: "sentry.report.audit",
    REPORT_PASSAGE_SEARCH: "sentry.report.passage.search",
    REPORT_PASSAGE_CHANGED_PLATES: "sentry.report.passage.changed.plates",
    REPORT_USER_SESSIONS: "sentry.report.user.sessions",
    REPORT_DISPATCH_ATTENDANCE_SEQUENCE: "sentry.report.dispatch.attendance.sequence",
    REPORT_MANAGEMENT_MATERIAL_MOVEMENTS: "sentry.report.management.material_movements",
    REPORT_MANAGEMENT_MATERIAL_CAUTIONS: "sentry.report.management.material_cautions",
    REPORT_DISPATCH_BO_APPREHENSIONS: "sentry.report.dispatch.bo.apprehensions",
    REPORT_DISPATCH_BO_STOLEN_ITEMS: "sentry.report.dispatch.bo.stolen_items",
    REPORT_DISPATCH_BO_AUDITORSHIP: "sentry.report.bo.auditorship",
    REPORT_DISPATCH_BO_TIMELINE: "sentry.report.bo.timeline",
    REPORT_DISPATCH_TIME_ARRIVAL: "sentry.report.dispatch.time.arrival",
    REPORT_DISPATCH_IMAGE_RESERVATION: "sentry.report.dispatch.image.reservation",
    REPORT_DISPATCH_DISPATCH_SEQUENCE: "sentry.report.dispatch.dispatch.sequence",
    REPORT_DISPATCH_DISPATCH_DISPLACEMENT_SEQUENCE: "sentry.report.dispatch.dispatch.displacement.sequence",
    GEOREF: "sentry.georef",
    PASSAGE_SEARCH_GEOREF: "sentry.passage.search.georef",
    REPORT_OCCURRENCE_REASON: "sentry.report.occurrence.reason",
    REPORT_OCCURRENCE_GEOREF_COMPARISON: "sentry.report.occurrence.georef.comparison",
    REPORT_DISPATCH_NATURE_ALL: "sentry.report.dispatch.nature.*",
    REPORT_DISPATCH_BO_ALL: "sentry.dispatch.bo.*",
    REPORT_DISPATCH_DISPATCH_XRAY: "sentry.report.dispatch.dispatch.xray",
    REPORT_DISPATCH_BO_XRAY: "sentry.report.dispatch.bo.xray",
    REPORT_SOS_XRAY: "sentry.report.sos.xray",
    REPORT_SOS_RECORDS: "sentry.report.sos.records",
    REPORT_SOS_MANAGEMENT: "sentry.report.sos.management",
    REPORT_SOS_HISTORY: "sentry.report.sos.history",
    REPORT_EVENT_LIST: "sentry.report.event.list",
    ALARM_PRINT: "sentry.alarm.print",
    ATTENDANCE: "sentry.dispatch.attendance",
    OCCURRENCE_PRINT: "sentry.occurrence.print",
    PASSAGE_EXPORT: "sentry.passage.export",
    PASSAGE_SEARCH_REPORT: "sentry.passage.search.report",
    REPORT_ALL: "sentry.report.*",
    REPORTS_ALL: "sentry.reports.*",
    REPORT_AGENT_PRODUCTIVITY: "sentry.report.agent_productivity",
    REPORT_AGENT_ABSENCES: "sentry.report.agent_absences",
    REPORT_ALARM_LIST: "sentry.report.alarm.list",
    REPORT_ALARMS_ACTIONS: "sentry.report.alarms.actions",
    REPORT_ALARMS_STATISTICS: "sentry.report.alarms.statistics",
    REPORT_CORPORATION_ACTIONS: "sentry.report.corporation_actions",
    REPORT_CORTEX_OCCURRENCE_ACTIONS: "sentry.report.cortex.occurrence.actions",
    REPORT_DISPATCH_ACTIVITY_LOG: "sentry.report.dispatch.activity.log",
    REPORT_DISPATCH_ATTENDANCE_AUDIT: "sentry.report.dispatch.attendance.audit",
    REPORT_DISPATCH_ATTENDANCE_QUALITY: "sentry.report.dispatch.attendance.quality",
    REPORT_DISPATCH_ATTENDANCE_XRAY: "sentry.report.dispatch.attendance.xray",
    REPORT_DISPATCH_BO_APPROVAL_ACTIONS: "sentry.report.dispatch.bo.approval_actions",
    REPORT_DISPATCH_BO_LIST: "sentry.report.dispatch.bo.list",
    REPORT_DISPATCH_DISPATCH_AUDIT: "sentry.report.dispatch.dispatch.audit",
    REPORT_DISPATCH_DISPATCH_QUALITY: "sentry.report.dispatch.dispatch.quality",
    REPORT_DISPATCH_BY_PLACE: "sentry.report.dispatch.dispatch_by_place",
    REPORT_DISPATCH_FIXED_POST_INSPECTION: "sentry.report.dispatch.fixed_post_inspection",
    REPORT_DISPATCH_GARRISON_ACTIONS: "sentry.report.dispatch.garrison.actions",
    REPORT_DISPATCH_GARRISON_AUDIT: "sentry.report.dispatch.garrison.audit",
    REPORT_DISPATCH_GARRISON_KM_CHECK: "sentry.report.dispatch.garrison.km.check",
    REPORT_DISPATCH_GARRISON_LIST: "sentry.report.dispatch.garrison.list",
    REPORT_DISPATCH_GARRISON_MAP: "sentry.report.dispatch.garrison.map",
    REPORT_DISPATCH_NATURE_ACTIONS: "sentry.report.dispatch.nature.actions",
    REPORT_DISPATCH_NATURE_DEVIATION: "sentry.report.dispatch.nature.deviation",
    REPORT_DISPATCH_RESPONSIBLE_BOGCM: "sentry.report.dispatch.responsible.bogcm",
    REPORT_DISPATCH_SCHEDULE_ATTENDANCE_AUDIT: "sentry.report.dispatch.schedule.attendance.audit",
    REPORT_DISPATCH_SCHEDULE_GARRISON_AUDIT: "sentry.report.dispatch.schedule.garrison.audit",
    REPORT_DISPATCH_SCHEDULE_GARRISON_LIST: "sentry.report.dispatch.schedule.garrison.list",
    REPORT_DISPATCH_VEHICLE_DAMAGE: "sentry.report.dispatch.vehicle.damage",
    REPORT_DISPATCH_VEHICLE_INSPECTION: "sentry.report.dispatch.vehicle.inspection",
    REPORT_DISPATCH_VEHICLE_KM_CONTROL: "sentry.report.dispatch.vehicle.km.control",
    REPORT_DOCUMENT_EXPIRATION: "sentry.report.management.document_expiration",
    REPORT_EFFECTIVE_TRAINING: "sentry.report.effective.training",
    REPORT_ENCOUNTER_HEAT_MAP: "sentry.report.encounter.encounter.heat.map",
    REPORT_ENCOUNTER_LIST: "sentry.report.encounter.encounter.list",
    REPORT_ENCOUNTER_XRAY: "sentry.report.encounter.xray",
    REPORT_EVENT_XRAY: "sentry.report.event.xray",
    REPORT_EXTERNAL_ALARMS_ACTIONS: "sentry.report.external_alarmes.actions",
    REPORT_MANAGEMENT_FLEET_MAINTENANCES: "sentry.report.management.fleet-maintenances",
    REPORT_MANAGEMENT_FLEET_SUPPLIES: "sentry.report.management.fleet_supplies",
    REPORT_NOTIFICATION_XRAY: "sentry.report.notification.xray",
    REPORT_NOTIFICATION_INFO: "sentry.report.notification_info",
    REPORT_OCCURRENCE_DASHBOARD: "sentry.report.occurrence.dash",
    REPORT_OCCURRENCE_MAP: "sentry.report.occurrence.map",
    REPORT_OCCURRENCE_QUALITY: "sentry.report.occurrence.quality",
    REPORT_OCCURRENCE_VEHICLE: "sentry.report.occurrence.vehicle",
    REPORT_OCCURRENCE_DETAILS: "sentry.report.occurrence_details",
    REPORT_PASSAGE_IMAGE_EXPORT: "sentry.report.passage.image.export",
    REPORT_PASSAGE_LABEL_XRAY: "sentry.report.passage.label.x.ray",
    REPORT_PASSAGE_SENTRY_CLOUD: "sentry.report.passage.sentrycloud",
    REPORT_PCL_CAMERA_SLA: "sentry.report.pcl.camera.sla",
    REPORT_PCL_OCR: "sentry.report.pcl.ocr",
    REPORT_PCL_PRIORITY: "sentry.report.pcl.priority",
    REPORT_PCL_SMARTCAPTURE_SLA: "sentry.report.pcl.smartcapture.sla",
    REPORT_SERVER_SLA: "sentry.report.server.sla",
    REPORT_SOLICITATION_XRAY: "sentry.report.solicitation.xray",
    REPORT_TRAFFIC_FLOW_POINT: "sentry.report.traffic.flow.point",
    REPORT_TRAFFIC_FLOW_ROUTE: "sentry.report.traffic.flow.route",
    REPORT_TRAFFIC_VEHICLE_STAY: "sentry.report.traffic.vehicle.stay",
    REPORT_USER_SYSTEM_USAGE: "sentry.report.user.system.usage",
    REPORT_MANAGEMENT_EQUIPMENTS_IN_USE: "sentry.reports.management.equipments_in_use",
    REPORT_GENERIC_FORM_ANALYSE: "sentry.report.generic_form_analyse",
    PASSAGE_LANE_ACCESS: "sentry.allow.lane.access",
    PASSAGE_SEARCH: "sentry.passage.search",
    PASSAGE_SEARCH_SENTRYCLOUD: "sentry.passage.search.sentrycloud",
    CORTEX: "sentry.search.cortex",
    CELEPAR: "sentry.search.celepar",
    CORTEX_PASSAGES: "sentry.search.cortex.passages",
    CORTEX_INDIVIDUAL: "sentry.search.cortex.individual",
    CORTEX_RENAVAM: "sentry.search.cortex.renavam",
    MURALHA_PAULISTA_PERSON: "sentry.muralha_paulista.search.person",
    MURALHA_PAULISTA_VEHICLE: "sentry.muralha_paulista.search.vehicle",
    GEOREF_ADMIN: "sentry.georef.admin",
    VMS: "sentry.vms",
    SENTRY_CLONE: "sentry.clone",
    OCCURRENCE: "sentry.occurrence",
    OCCURRENCE_INTELLIGENCE: 'sentry.occurrence.localinteligence',
    OCCURRENCE_PUBLIC: 'sentry.occurrence.localpublic',
    OCCURRENCE_MYUSER: 'sentry.occurrence.myuser',
    GIS: "sentry.gis",
    CELEPAR_RENAVAM: "sentry.search.celepar.renavam",
    CELEPAR_DRIVER: "sentry.search.celepar.driver",
    CAPTURE_PLACE: "sentry.captureplace.admin",
    NOC: "sentry.captureplace.noc",
    PASSAGE_LIMIT_TIME: "sentry.passage.search.limit.time",

    USER: "sentry.user.admin",
    SENTRY_CLOUD: "sentry.sentrycloud.admin",
    CONFIGURATION: "sentry.configuration.admin",

    /* Dispatch */
    DISPATCH_ADMIN: "sentry.dispatch.admin",
    DISPATCH_ACTIVITY: "sentry.dispatch.activity",
    DISPATCH_ACTIVITY_SUBORDINATES: "sentry.dispatch.activity_subordinates",
    ATTENDANCE_WEB: "sentry.dispatch.attendance.web",
    ATTENDANCE_MOBILE: "sentry.dispatch.attendance.mobile",
    ATTENDANCE_VISUALIZATION: "sentry.dispatch.attendance_visualization",
    ATTENDANCE_SCHEDULE: "sentry.dispatch.attendance_schedule",
    ATTENDANCE_SCHEDULE_CALENDAR: "sentry.dispatch.attendance.schedule.calendar",

    DISPATCH_DISPATCH: "sentry.dispatch.dispatch",
    ATTENDANCE_APP_ALLOW_VIEW_CALL: "sentry.dispatch.attendance.app_allow_view_call",
    RETROACTIVE: "sentry.dispatch.retroactive",
    DISPATCH: "sentry.dispatch",
    GARRISON_WEB: "sentry.dispatch.garrison.web",
    GARRISON_MOBILE: "sentry.dispatch.garrison.mobile",
    MY_GARRISON: "sentry.dispatch.mygarrison",
    GARRISON_LEADER: "sentry.dispatch.garrison_leader",
    GARRISON_SCHEDULE: "sentry.dispatch.garrison.schedule",
    DISPATCH_TASK_WEB: "sentry.dispatch.task.web",
    CONTINGENT: "sentry.dispatch.contingent",
    MYGARRISON: "sentry.dispatch.mygarrison",
    SCHEDULE_ALL_GARRISONS: "sentry.dispatch.mobile.schedule_all_garrisons",
    ERP_ANIMALS: "sentry.erp.animals",
    MATERIALS_REMOVED_BY_THIRD_PERSON: "sentry.erp.materials.removed.by.third.parties",

    OCCURRENCE_MYGROUPS: "sentry.occurrence.mygroups",
    OCCURRENCE_ADMIN: "sentry.occurrence.admin",
    DUTY_INFORMATION: "sentry.dispatch.duty_information",
    CREATE_MESSAGE: "sentry.messages.create",
    ALARM_CONFIGURATIONS: "sentry.manage.alarm.configurations",
    ALARM_INACTIVATE: "sentry.inactivate.alarm",

    VIDEO_CAMERA: "sentry.videocamera.admin",

    RECEIVE_EVENTS_AGENT_APP: "sentry.sos.receive_events_in_agent_app",

    PASSAGE_LABEL: "sentry.crud.passage.label",

    SIGN_INDIVIDUAL_ALARM: "sentry.sign.individual.alarm",

    USER_DOCUMENTS: "sentry.user.documents",
    USER_TRAININGS: "sentry.user.trainings",
    USER_CONDUCT_HISTORY: "sentry.user.conduct_history",
    USER_PRIVATE_WEAPONS: "sentry.user.private_weapons",
    USER_ABSENCES: "sentry.user.absences",
    USER_CLOTHES: "sentry.user.clothes",
    USER_DEPENDENTS: "sentry.user.dependents",
    SKILLS_RESTRICTIONS: "sentry.user.skills_restrictions",
    USER_ATTACHS: "sentry.user.attachs",

    STANDARD_OPERATING_PROCEDURES: "sentry.standard_operating_procedures.crud",
    LIBRARY_MANAGE: "sentry.library.manage",
    CONTACTID_EVENTS_OPERATING_GROUPS: "sentry.contactid.events.operating_groups",

    ECAP: "sentry.intelligence.ecap",
    ECAP_TEMPLATE: "sentry.intelligence.ecap_template",

    DISPATCH_GARRISON_VEHICLE: "sentry.dispatch.garrison.vehicle",

    PASSAGE_RESTRICTED_LANE_ACCESS: "sentry.allow.restricted.lane.access",
    CAPTURE_PLACE_NOC: "sentry.captureplace.noc",
    DISPATCH_GARRISON_LEADER: "sentry.dispatch.garrison_leader",
    ADR_CODE: "sentry.adr.code",
    ADR_CODE_SEARCH: "sentry.adr.code.search",
    ADR_MONITORING: "sentry.adr.monitoring",

    SENTRY_PHONE_CONFIG: "sentry.phone.config",
    SENTRY_PHONE_CALL_LOG: "sentry.phone.call.log",

    DASHBOARD_WALL: "sentry.dashboard.wall",
    GARRISON_TIMELINE: "sentry.dispatch.garrison.timeline",
}
